// extracted by mini-css-extract-plugin
export default {"head":"Contact_head__GqRo4","layout":"Contact_layout__WKvf5","info":"Contact_info__goHVR","item":"Contact_item__p7+8Z","value":"Contact_value__dqbw5","label":"Contact_label__YmiER"};